import axios from 'axios';
import { AuthActions, clearStoredAuthData, getStoredRefreshToken } from '../../store/auth-slice';
import store from '../../store';
import { baseUrl } from '../../utils/utils';
import { refreshIdToken } from './login/LoginApi';

export const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log('Environment check', process.env.REACT_APP_ENV);
console.log('base_url', baseUrl);

let isTargetCanteenInterceptorAttached = false;
let logoutInterceptorId;
let refreshTokenPromise = null;

export const setAxiosAuthToken = (authToken) => {
  if (authToken) {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  } else {
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};

export const clearAxiosAuthToken = () => {
  delete axiosInstance.defaults.headers.common.Authorization;
};

const performLogout = (navigate, dispatch) => {
  clearAxiosAuthToken();
  clearStoredAuthData();
  dispatch(AuthActions.logout());
  navigate('/', { replace: true });
};

const getRefreshedIdToken = async (dispatch) => {
  const storedRefreshToken = getStoredRefreshToken();

  if (!storedRefreshToken) {
    throw new Error('Refresh token is missing or expired');
  }

  if (!refreshTokenPromise) {
    refreshTokenPromise = refreshIdToken(storedRefreshToken)
      .then((response) => {
        const { idToken, refreshToken } = response.data ?? {};

        if (!idToken) {
          throw new Error('ID token was not returned from refresh endpoint');
        }

        dispatch(AuthActions.updateAuthToken(idToken));
        setAxiosAuthToken(idToken);

        if (refreshToken) {
          dispatch(AuthActions.updateRefreshToken(refreshToken));
        }

        return idToken;
      })
      .finally(() => {
        refreshTokenPromise = null;
      });
  }

  return refreshTokenPromise;
};

// Check if user is logged in.
(function () {
  let authToken = localStorage.getItem('token');
  if (authToken === null) {
    clearAxiosAuthToken();
  } else {
    setAxiosAuthToken(authToken);
  }
})();

const getTargetCanteenId = () => {
  const { user } = store.getState().auth;
  const isSuperAdmin = user?.roles?.includes('SuperAdmin');

  if (!isSuperAdmin) {
    return null;
  }

  return user?.canteen?.id ?? null;
};

if (!isTargetCanteenInterceptorAttached) {
  axiosInstance.interceptors.request.use((config) => {
    const targetCanteenId = getTargetCanteenId();

    config.headers = config.headers ?? {};

    if (targetCanteenId) {
      config.headers.targetCanteenId = targetCanteenId;
    } else {
      delete config.headers.targetCanteenId;
    }

    return config;
  });

  isTargetCanteenInterceptorAttached = true;
}

export const setupLogoutMechanism = (navigate, dispatch) => {
  if (logoutInterceptorId !== undefined) {
    return;
  }

  logoutInterceptorId = axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (err) => {
      const originalConfig = err.config ?? {};
      console.dir('token err');
      console.dir(err);

      const isRefreshRequest = originalConfig.url?.includes('/public/token');

      if (
        err?.response?.status === 401 &&
        !originalConfig._retry &&
        !isRefreshRequest
      ) {
        originalConfig._retry = true;

        try {
          const idToken = await getRefreshedIdToken(dispatch);
          originalConfig.headers = originalConfig.headers ?? {};
          originalConfig.headers.Authorization = `Bearer ${idToken}`;
          return axiosInstance(originalConfig);
        } catch (_error) {
          performLogout(navigate, dispatch);
          return Promise.reject(_error);
        }
      }

      if (err?.response?.status === 401) {
        performLogout(navigate, dispatch);
      }

      return Promise.reject(err);
    }
  );
};
